module.exports = function () {
    
    var $videoHero = $('.video-hero');

    var resizeVideo = function () {
        var containerWidth = $videoHero.width();
        var containerHeight = $videoHero.outerHeight();
        
        var aspect = containerWidth / containerHeight;
        var sixteenNineAspect = 16 / 9;
        var width, height;
        
        if (aspect < sixteenNineAspect) {
            height = containerHeight;
            width = height * sixteenNineAspect;
        }
        else {
            width = containerWidth;
            height = width / sixteenNineAspect;
        }

        var $wistiaContainer = $videoHero.find('.wistia_responsive_padding');
        $wistiaContainer.css('width', width + 'px').css('height', height + 'px');
    };

    if ($videoHero.length) {
        resizeVideo();

        $(window).resize(function () {
            requestAnimationFrame(resizeVideo);
        });
    }
};